import "./footer-uqam.scss";